import React, { PureComponent } from 'react';
import { ApolloError } from 'apollo-client';
import classNames from 'classnames';
import { noop } from 'lodash';

import { IconButton, Portal, Snackbar, Typography } from '@material-ui/core';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme: Theme) =>
  createStyles({
    content: {
      color: theme.custom.palette.black1,
      backgroundColor: theme.custom.palette.redLight,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      color: theme.custom.palette.terracotta,
      marginRight: theme.spacing(2),
    },
    contained: {
      position: 'static',
      transform: 'none',
      marginBottom: theme.spacing(2),
    },
    close: {
      padding: theme.spacing(0.5),
    },
  });

interface IProps extends WithStyles<typeof styles> {
  message: string | object | ApolloError;
  contained?: boolean;
  onClose?: () => void;
}

interface IState {
  open: boolean;
}

class Error extends PureComponent<IProps, IState> {
  static defaultProps = {
    contained: false,
    onClose: noop,
  };

  state: IState = {
    open: true,
  };

  getMessage() {
    const { classes, message } = this.props;

    const convertedMessage = String(message);
    const formattedMessage = convertedMessage.replace('GraphQL error: ', '');

    return (
      <span className={classes.message}>
        <ErrorOutlineIcon className={classes.icon} />
        <Typography variant="subtitle2">{formattedMessage}</Typography>
      </span>
    );
  }

  getAction() {
    const { classes } = this.props;

    return [
      <IconButton
        key="close"
        aria-label="Close"
        color="inherit"
        className={classes.close}
        onClick={this.handleClose}>
        <CloseIcon />
      </IconButton>,
    ];
  }

  handleClose = () => {
    const { onClose } = this.props;
    this.setState({ open: false }, onClose);
  };

  render() {
    const { classes, contained, message } = this.props;
    const { open } = this.state;

    if (!message) {
      return null;
    }

    const snackbarClasses = classNames({
      [classes.contained]: contained,
    });

    return (
      <Portal disablePortal={contained}>
        <Snackbar
          className={snackbarClasses}
          ContentProps={{ className: classes.content }}
          open={open}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={this.handleClose}
          message={this.getMessage()}
          action={this.getAction()}
        />
      </Portal>
    );
  }
}

export default withStyles(styles)(Error);
